/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(0), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    comboBox.$inject = ["$timeout"];
    angular.module('ecComboBox', ['mstarCore']).directive('ecComboBox', comboBox);

    function comboBox($timeout) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {
                ngModel: '=',
                ngConfig: '=?',
                inputData: '=?inputData'
            },
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {

            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            if (attr.inputData) {
                scope.instance.setModel(scope.inputData || {});
                mstarComponent.bindModel(scope);
                scope.$watch('inputData', function (currVal) {
                    if (currVal) {
                        scope.instance.setModel(currVal);
                        mstarComponent.bindModel(scope);
                    }
                }, true);
            } else {
                mstarComponent.bindModelData(scope);
            }

            // use for dynamic instance to update the parameters passed from config
            if (attr.ngConfig) {
                var parameters = scope.instance.getParameters(),
                    keys = _.keys(scope.ngConfig);

                _.each(keys, function (key) {
                    if (parameters.hasOwnProperty(key)) {
                        scope.instance.setParameter(key, scope.ngConfig[key]);
                    }
                });
            }
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var selectorComboBox = '__select',
                displaySettings = scope.parameters.displaySettings,
                selectElement,
                currentTemplate = '_templates.main';

            if (scope.parameters.groupByField) {
                if (displaySettings.multiple) {
                    currentTemplate = '_templates.groupedMultiSelect';
                } else {
                    currentTemplate = '_templates.groupedSingleSelect';
                }
            } else if (displaySettings.multiple) {
                currentTemplate = '_templates.multiSelect';
            }

            mstarComponent.compileTemplate(scope, currentTemplate);

            var findSelectElem = function findSelectElem() {
                if (!selectElement || !selectElement.length) {
                    selectElement = elem.find('.' + scope.settings.get('namespaceClass') + selectorComboBox);
                }
            };

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:listItems', function () {
                $timeout(function () {
                    selectElement.trigger('change');
                }, 0);
            }));

            $timeout(function () {
                findSelectElem();
                if (scope.ngConfig && scope.ngConfig.placeholder) {
                    displaySettings.placeholder = scope.labels.get(scope.ngConfig.placeholder);
                } else if (scope.labels.contains('placeholder')) {
                    displaySettings.placeholder = scope.labels.get('placeholder');
                }
                selectElement.select2(displaySettings);

                // If using label option, change the default label for the combo-box to the main label
                // This is because screen readers will otherwise hear the first option in the list
                // which in a lot of cases is just the word "All" so users won't know what the combo-box is for
                if (scope.settings.get('ariaLabelledBy') === 'label') {
                    var combobox = elem.find('[role="combobox"]');
                    combobox.attr('aria-labelledby', scope.namespaceId('label'));
                }
            }, 0);

            var refreshSelect = function refreshSelect() {
                $timeout(function () {
                    findSelectElem();
                    selectElement.trigger('change.select2');

                    // Add a title attribute to the combo-box so the default item is read out by screen readers
                    if (scope.settings.get('ariaLabelledBy') === 'label') {
                        var combobox = elem.find('[role="combobox"]'),
                            selected = elem.find('.select2-selection__rendered');
                        combobox.attr('title', selected.attr('title'));
                    }
                }, 0);
            };

            scope.$watch('ngModel', refreshSelect);

            var destroySelect2 = function destroySelect2() {
                findSelectElem();

                if (selectElement.data('select2')) {
                    selectElement.select2('destroy');
                }
            };

            scope.$on('$destroy', destroySelect2);
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = {
	"ecComboBox": {
		"components": {},
		"labels": {
			"caption": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"placeholder": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"listItems": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": []
				}
			},
			"_parameters": {
				"disabled": {},
				"displaySettings": {},
				"groupByField": {},
				"runtimeSelectLabel": {}
			},
			"_templates": {
				"groupedMultiSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label data-ng-if=\"labels.contains('caption')\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId() }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId() }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] group by listItem[parameters.groupByField]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\"\r\n            multiple=\"multiple\">\r\n    </select>\r\n</div>\r\n",
				"groupedSingleSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label data-ng-if=\"labels.contains('caption')\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId() }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId() }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')] group by listItem[parameters.groupByField]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\">\r\n        <option data-ng-if=\"labels.contains('placeholder') || (ngConfig && ngConfig.placeholder)\" value=\"\"></option>\r\n    </select>\r\n</div>\r\n",
				"main": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label id=\"{{ ::namespaceId('label') }}\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId('select') }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\">\r\n        <option data-ng-if=\"labels.contains('placeholder') || (ngConfig && ngConfig.placeholder)\" value=\"\"></option>\r\n    </select>\r\n</div>\r\n",
				"multiSelect": "<div class=\"{{ ::namespaceClass('__wrapper') }}\">\r\n    <label id=\"{{ ::namespaceId('label') }}\" class=\"{{ ::namespaceClass('__label') }}\" for=\"{{ ::namespaceId('select') }}\">{{labels.get(\"caption\")}}</label>\r\n    <select data-ng-model=\"ngModel\"\r\n            data-ng-disabled=\"parameters.disabled\" id=\"{{ ::namespaceId('select') }}\"\r\n            class=\"{{ ::namespaceClass('__select') }}\"\r\n            data-ng-options=\"parameters.runtimeSelectLabel && labels.contains(listItem[settings.get('valueField')]) ?\r\n             labels.get(listItem[settings.get('valueField')]) : listItem[settings.get('valueField')]\r\n            for listItem in model.listItems track by listItem[settings.get('keyField')]\"\r\n            multiple=\"multiple\">\r\n    </select>\r\n</div>\r\n"
			},
			"ariaLabelledBy": "label",
			"disabled": false,
			"displaySettings": {
				"containerCssClass": "mui-combo-box__container",
				"dropdownCssClass": "mui-combo-box__dropdown",
				"theme": "default mui-combo-box",
				"width": "200"
			},
			"groupByField": false,
			"keyField": "key",
			"namespaceClass": "ec-combo-box",
			"runtimeSelectLabel": true,
			"valueField": "value"
		},
		"type": "ecComboBox"
	}
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecComboBox', __webpack_require__(2).ecComboBox);
    morningstar.asterix.meta.register('ecComboBox', 'allowedEvents', ['ecComboBoxItemSelected']);
    __webpack_require__(1);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-combo-box.js.map


// WEBPACK FOOTER //
// ./components/combo-box/build/ec-combo-box.js